import {
  Input,
  Component,
  forwardRef,
  ChangeDetectionStrategy,
}
from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgClass, NgTemplateOutlet } from '@angular/common';

/**
 * interfaces
 */
import { IFormInputFieldUI } from '@sharedModules/forms/directives/form-input-field/interfaces/form-input-field';

/**
 * models
 */
import { FormFieldHighOrderDirectiveBase } from '@sharedModules/forms/high-orders/form-field-high-order-directive';

/**
 * directives
 */
import { FormInputFieldDirective } from '@sharedModules/forms/directives/form-input-field/form-input-field.directive';
import { FormFieldStatusDirective } from '@sharedModules/forms/directives/form-field-status/form-field-status.directive';
import { FormFieldFeedbackDirective } from '@sharedModules/forms/directives/form-field-feedback/form-field-feedback.directive';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrl: './textarea.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.position-relative]': 'isFeedbackProviderTooltip'
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true
    }
  ],
  imports: [
    NgClass,
    NgTemplateOutlet,
    /**
     * directives
     */
    FormInputFieldDirective,
    FormFieldStatusDirective,
    FormFieldFeedbackDirective
  ],
})
export class TextareaComponent extends FormFieldHighOrderDirectiveBase<string> implements IFormInputFieldUI {

  /**
   * 
   */
  @Input({ alias: 'value' })
  public value: string = '';

  /**
   * 
   */
  @Input({ alias: 'rows' })
  public rows: number = 3

  /**
   * 
   */
  public get templateContext() {
    return {
      id: this.id,
      label: this.label,
      value: this.value,
      valid: this.valid,
      touched: this.touched,
      invalid: this.invalid,
      disabled: this.disabled,
      placeholder: this.placeholder,
    }
  }

  /**
   * 
   */
  public onInputChange(event: Event): void {

    // get element
    // ES6 Destruction
    const { value } = event.target as HTMLTextAreaElement;

    // update inner value
    this.value = value;

    // update control value
    if (this.control != null) {
      this.onChange(this.value);
    }

    // emit eventEmitter
    this.onChangeEvent.emit(this.value);

  }

  /**
   * 
   */
  public onInputTouched(): void {

    // update control status 
    if (this.control != null) {
      this.onTouched();
    }

  }

}